import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const saleCommissionPdf = () => {
    const store = useStore();
    const {commaFormat} = figureFormatter();
    const {getHeader, getFooter} = pdfHeaderFooter();
    const userName = store.state.user.user.name;

    const exportToPDF = (company, companySaleShareData, tableItems, totalValue, month) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [10, 100, 10, 80],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(companySaleShareData, tableItems, totalValue, month),

            styles: {
                header: {
                    fontSize: 24,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 8,
                font: 'SulaimanLipi'
            },

            info: {
                title: 'Sale Commission -' + formatYearMonth(month),
            }
        }

        pushIntoTable(doc, tableItems, totalValue)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    function formatYearMonth(value) {
        if (!value) return '';
        const [year, month] = value.split('-');
        return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long' })
            .format(new Date(year, month - 1));
    }

    const getContent = (companySaleShareData, tableItems, totalValue, month) => {
        return [
            {
                text:  'Sale Commission -' + formatYearMonth(month),
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                fontSize: 12,
                decoration: 'underline'
            },

            {
                columns: [
                    {
                        width: '50%',
                        table: {
                            body: totalSummaryData(companySaleShareData, totalValue),
                            widths: ['60%', '40%']
                        },
                        layout: {
                            fillColor: function (rowIndex) {
                                return (rowIndex === 0) ? '#f3f2f7' : null;
                            },
                            hLineWidth: function () { return 0.5; },
                            vLineWidth: function () { return 0.5; }
                        },
                        margin: [0, 10, 0, 0]
                    },
                    { width: '*', text: '' }
                ]
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    body: [],
                    widths: [ '10%', '10%', '10%', '10%', '10%', '10%', '10%', '10%', '10%', '10%'  ]
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    body: companySaleShareDta(companySaleShareData),
                    widths: [ '10%', '15%', '15%', '15%', '15%', '15%', '15%']
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },
        ]
    }

    function totalSummaryData(companySaleShareData, totalValue) {
        return [
            [
                { text: 'Particulars'},
                { text: 'Amount', alignment: 'right' },
            ],
            [
                { text: 'A. Personal Sales Commission'},
                { text: commaFormat(totalValue.personal_sale_commission_amount), alignment: 'right' },
            ],
            [
                { text: 'B. Group Sales Commission'},
                { text: commaFormat(totalValue.group_sale_commission_amount), alignment: 'right' },
            ],
            [
                { text: 'C. Company Sales Share'},
                { text: commaFormat(companySaleShareData.distributed_company_share_amount), alignment: 'right' },
            ],
            [
                { text: 'D. BP Commission'},
                { text: commaFormat(totalValue.bp_commission_amount), alignment: 'right' },
            ],
            [
                { text: 'Total Commission', bold: true},
                { text: commaFormat(totalValue.bp_commission_amount + totalValue.sale_commission_amount + companySaleShareData.distributed_company_share_amount), alignment: 'right' },
            ],
        ];
    }

    function companySaleShareDta(companySaleShareData) {
        let dataRow = [
            [
                { text: 'Level Qualified'},
                { text: 'Equivalent Designation'},
                { text: 'Company Sales Share %', alignment: 'right' },
                { text: 'Total Company Sales', alignment: 'right' },
                { text: 'Total Company Sales Share', alignment: 'right' },
                { text: 'Total Qualified Team This month', alignment: 'right' },
                { text: 'Company Sales Share Amount', alignment: 'right' },
            ]
        ];

        dataRow.push([
            { text: 'C. COMPANY SALE SHARE', colSpan: 7, bold: true, alignment: 'left' },
            {}, {}, {}, {}, {}, {}
        ]);

        companySaleShareData.data.forEach(item => {
            dataRow.push([
                {text: item.level_name},
                {text: item.equivalent_designation},
                {text: item.company_sale_share_percentage + '%', alignment: 'right'},
                {text: commaFormat(item.total_company_sales), alignment: 'right'},
                {text: commaFormat(item.total_company_sale_share), alignment: 'right'},
                {text: item.total_qualified_member, alignment: 'right'},
                {text: commaFormat(item.distributed_company_share_amount), alignment: 'right'},
            ]);
        });

        dataRow.push([
            {text: 'Total', colSpan: 5, alignment: 'center', bold: true}, {}, {}, {}, {},
            {text: companySaleShareData.total_qualified_member, alignment: 'right', bold: true},
            {text: commaFormat(companySaleShareData.distributed_company_share_amount), alignment: 'right', bold: true}
        ]);

        return dataRow;
    }

    const pushIntoTable = (doc, tableItems, totalValue) => {
        const tableHeader = getTableHeader();
        doc.content[2].table.body.push(tableHeader);
        let rows = getCommissionTable(tableItems, totalValue);
        doc.content[2].table.body.push(...rows);
    }

    const getCommissionTable = (tableItems, totalValue) => {
        const body = [];

        body.push([
            {text: 'A. PERSONAL SALES COMMISSION', colSpan: 10, bold: true, alignment: 'left'},
            {}, {}, {}, {}, {}, {}, {}, {}, {}
        ]);

        tableItems.filter(i => i.generation === 0).forEach(item => {
            body.push([
                {text: item.serial_no},
                {text: item.name},
                {text: `${item.level_name} (${item.equivalent_designation})`},
                {text: item.parent_serial_no, alignment: 'right'},
                {text: commaFormat(item.allocated_sales_amount), alignment: 'right'},
                {text: `${item.sales_commission_percentage}%`, alignment: 'right'},
                {text: commaFormat(item.sales_commission_amount), alignment: 'right'},
                {text: 'Not Applicable for Personal sales', colSpan: 3, alignment: 'center'},
                {}, {}
            ]);
        });

        body.push([
            {text: 'B. GROUP SALES COMMISSION', colSpan: 10, bold: true, alignment: 'left'},
            {}, {}, {}, {}, {}, {}, {}, {}, {}
        ]);

        tableItems.filter(i => i.generation > 0).forEach(item => {
            body.push([
                {text: item.serial_no},
                {text: item.name},
                {text: `${item.level_name} (${item.equivalent_designation})`},
                {text: item.parent_serial_no},
                {text: commaFormat(item.allocated_sales_amount), alignment: 'right'},
                {text: `${item.group_commission_percentage}%`, alignment: 'right'},
                {text: commaFormat(item.group_commission_amount), alignment: 'right'},
                {text: item.generation, alignment: 'right'},
                {text: `${item.bp_commission_percentage}%`, alignment: 'right'},
                {text: commaFormat(item.bp_commission_amount), alignment: 'right'},
            ]);
        });

        body.push([
            {text: 'Total', colSpan: 4, alignment: 'center', bold: true}, {}, {}, {},
            {text: commaFormat(totalValue.sale_allocation_amount), alignment: 'right', bold: true},
            {text: '', alignment: 'center'},
            {text: commaFormat(totalValue.sale_commission_amount), alignment: 'right', bold: true},
            {text: '', alignment: 'center'},
            {text: '', alignment: 'center'},
            {text: commaFormat(totalValue.bp_commission_amount), alignment: 'right', bold: true}
        ]);

        return body;
    }

    const getTableHeader = () => {
        const tableHeader = [
            {text: 'Staff ID'},
            {text: 'Staff Name'},
            {text: 'Designation'},
            {text: 'Ref ID'},
            {text: 'Allocated Sales Amount', alignment: 'right'},
            {text: 'Com %', alignment: 'right'},
            {text: 'Sales Commission', alignment: 'right'},
            {text: 'Generation', alignment: 'right'},
            {text: 'BP Com %', alignment: 'right'},
            {text: 'BP Commission Amount', alignment: 'right'},
        ]

        return tableHeader
    }

    return {
        exportToPDF
    }
}

export default saleCommissionPdf;